import { trackCreditsPageRedirect } from "@/analytics/tracking";
import { Banner } from "@/components/Banner/Banner";
import { SubscriptionRestrictionSvg } from "@/components/Icon/Icon";
import { useOrgCredits } from "@/hooks/credits";
import { Scope, usePermissions } from "@/hooks/permissions";
import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

export const NoCreditsBanner = () => {
  const { t } = useTranslation("subscription");
  const theme = useTheme();
  const { isOutOfCredits, isLoading } = useOrgCredits({});
  const { [Scope.UpdateFinancials]: canPurchaseCredits } = usePermissions();

  return isOutOfCredits && !isLoading ? (
    <Box component="div" sx={{ marginBottom: "12px" }}>
      <Banner
        title={t("title.noCredits")}
        description={t("description.noCredits")}
        linkText={canPurchaseCredits ? t("button.purchaseCredits") : undefined}
        onLinkClick={() => {
          if (canPurchaseCredits) {
            trackCreditsPageRedirect();
            window.open("/credits", "_blank");
          }
        }}
        icon={<SubscriptionRestrictionSvg color={theme.palette.info.main} />}
      />
    </Box>
  ) : (
    <></>
  );
};
